import {
  REACT_APP_FEATURE_FLAG_ENABLE_CIVIL_REGISTRY,
  REACT_APP_FEATURE_FLAG_FOREIGN_ENROLLMENT,
  REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS,
  REACT_APP_FEATURE_FLAG_UNIQUE_PASS,
  REACT_APP_FEATURE_FLAG_DNI_TEST_INPUT_ENABLED
} from '../../config/settings/environment'

export const features = {
  'com.seller/foreign.enrollment':
    REACT_APP_FEATURE_FLAG_FOREIGN_ENROLLMENT === true || REACT_APP_FEATURE_FLAG_FOREIGN_ENROLLMENT === 'true',
  'com.seller/recovery.admin':
    REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN === true || REACT_APP_FEATURE_FLAG_RECOVERY_ADMIN === 'true',
  'com.seller/taxes.key.checks':
    REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === true || REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === 'true',
  'com.seller/unique.pass':
    REACT_APP_FEATURE_FLAG_UNIQUE_PASS === true || REACT_APP_FEATURE_FLAG_UNIQUE_PASS === 'true',
  'com.seller/dni.test.input':
    REACT_APP_FEATURE_FLAG_DNI_TEST_INPUT_ENABLED === true || REACT_APP_FEATURE_FLAG_DNI_TEST_INPUT_ENABLED === 'true',
  'enable.civil.registry':
    REACT_APP_FEATURE_FLAG_ENABLE_CIVIL_REGISTRY === true || REACT_APP_FEATURE_FLAG_ENABLE_CIVIL_REGISTRY === 'true'
}
